import { Box, Typography, useTheme, useMediaQuery } from '@mui/material';
import { FC } from 'react';
import { Trans, useTranslation } from 'react-i18next';

import { PaymentOptionBanner } from 'src/components/payment-option-banner';
import { ReactComponent as AlertIcon } from 'src/assets/svg/alert-icon.svg';
import { ReactComponent as SageLogo } from 'src/assets/svg/sage-logo.svg';
import { Button } from 'src/components/button';

import { styles } from './styles';

export const AbortedPage: FC = () => {
    const { t } = useTranslation();
    const theme = useTheme();
    const isSmallScreen = useMediaQuery(theme.breakpoints.down('lg'));

    return (
        <Box css={styles.container}>
            <Box css={styles.imageContainer} />

            <Box css={styles.wrapper}>
                <AlertIcon />

                <Typography variant="h1">{t('alert_title')}</Typography>

                <Typography variant="body3">
                    <Trans i18nKey="alert_content" components={{ br: <br />, b: <b /> }} />
                </Typography>

                <Typography variant="body3">
                    <Trans i18nKey="alert_content2" />
                </Typography>

                <Button variant="contained" css={styles.cta}>
                    {t('alert_btn_review')}
                </Button>

                <Typography variant="body3">
                    <Trans i18nKey="alert_content3" />
                </Typography>

                <Button variant="contained" css={styles.cta}>
                    {t('alert_btn_retry')}
                </Button>

                <Box css={styles.sageWrapper}>
                    <SageLogo />
                    <Typography>{t('failure_sage_redirect')}</Typography>
                </Box>
            </Box>

            {isSmallScreen && <PaymentOptionBanner />}
        </Box>
    );
};
